import { z } from 'zod';
export const CONSULTATION_VISIT_TYPE = ['new', 'follow_up', 'internal_referral'];
export const CONSULTATION_CHARGE_AT = ['booking', 'arrival', 'close'];
export const PAY_BEFORE_CONSULTATION = ['off', 'warn', 'block'];
export const OPD_BILLING_ISSUE = ['no_fee_rule', 'no_price', 'coverage_invalid', 'error'];
export const CONSULTATION_FEE_STATE = ['free', 'paid', 'due', 'insured_due', 'insured_paid', 'not_billed', 'no_price'];
export const opdUnbilledQuerySchema = z.object({
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    branchId: z.string().uuid().optional(),
    cursor: z.string().uuid().optional(),
});
export function consultationVisitType(type) {
    return CONSULTATION_VISIT_TYPE.includes(type ?? '') ? type : 'new';
}
export function patientBalanceOf(invoice) {
    return Math.max(0, invoice.netMinor - invoice.creditMinor - invoice.paidMinor);
}
const LIVE = (invoice) => !['cancelled', 'refunded', 'void'].includes(invoice.status);
const PAID = (invoice) => invoice.status !== 'draft' && patientBalanceOf(invoice) <= 0;
export function standingBillingIssue(visit) {
    if (!visit.billingIssue)
        return null;
    return visit.invoices.some((invoice) => LIVE(invoice) && invoice.consultation === true) ? null : visit.billingIssue;
}
export function consultationSettled(visit) {
    const live = visit.invoices.filter(LIVE);
    if (visit.free)
        return live.every(PAID);
    if (standingBillingIssue(visit))
        return false;
    return live.length > 0 && live.every(PAID);
}
export function effectiveFeeGate(settings) {
    return settings.consultationChargeAt === 'close' ? 'off' : settings.payBeforeConsultation;
}
export function consultationFeeState(visit) {
    if (visit.free)
        return visit.invoices.filter(LIVE).every(PAID) ? 'free' : 'due';
    const issue = standingBillingIssue(visit);
    if (issue === 'no_fee_rule' || issue === 'no_price')
        return 'no_price';
    const live = visit.invoices.filter(LIVE);
    if (live.length === 0)
        return 'not_billed';
    const insured = live.some((invoice) => invoice.payerId !== null);
    const settled = live.every(PAID);
    if (insured)
        return settled ? 'insured_paid' : 'insured_due';
    return settled ? 'paid' : 'due';
}
//# sourceMappingURL=consultation-fee-rule.js.map